import { render, staticRenderFns } from "./SuccessSubmitForm3.vue?vue&type=template&id=5bad8280&scoped=true"
import script from "./SuccessSubmitForm3.vue?vue&type=script&lang=ts"
export * from "./SuccessSubmitForm3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bad8280",
  null
  
)

export default component.exports